import React from 'react';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import { getPriceWithSymbol } from 'utilities/price/price-utilities';
import { Typography } from '@tvg/fuse/typography';
import { Checkbox } from '@tvg/fuse/checkbox';
import styles from './Addon.module.css';

export function Addon() {
  const { filteredLinkedAddonServicesContent, handleLinkedAddonServiceSelectionChange } = useSelectedSkuContext();

  if (!filteredLinkedAddonServicesContent) {
    return null;
  }

  const lastIndex = filteredLinkedAddonServicesContent ? filteredLinkedAddonServicesContent.length - 1 : 0;

  if (filteredLinkedAddonServicesContent?.length > 0) {
    return (
      <>
        <Typography className={styles.header} tag="h3" size="1">
          + Optional services
        </Typography>

        {filteredLinkedAddonServicesContent?.map((service, index) => (
          <div key={service.productId} className={styles.container}>
            <Checkbox
              isChecked={service.isSelected}
              onChange={() => {
                handleLinkedAddonServiceSelectionChange(index);
              }}
              name={service.productId}
            >
              <div className={styles.item}>
                <div className={styles.titleRow}>
                  <Typography className={styles.title} size="1" tag="p" type="paragraph" dataTestId="addon-item-title">
                    {service?.title}
                  </Typography>
                  <Typography className={styles.title} size="1" tag="div" dataTestId="addon-item-price">
                    {typeof service?.price?.now?.basePrice === 'number'
                      ? getPriceWithSymbol(service?.price?.now?.basePrice, service?.price?.now?.currencyCode)
                      : ''}
                  </Typography>
                </div>

                <Typography size="m1" tag="p" type="paragraph" dataTestId="addon-item-description">
                  {service?.description}
                </Typography>
              </div>
            </Checkbox>
            {index === lastIndex && (
              <Typography
                className={styles.deliveryNote}
                size="m2"
                tag="p"
                type="paragraph"
                dataTestId="addon-item-delivery-description"
              >
                Services may affect delivery dates.
              </Typography>
            )}
          </div>
        ))}
      </>
    );
  }
  return null;
}

export default Addon;
